import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface SmartImageProps {
  src: string;
  alt: string;
  className?: string;
  aspectRatio?: string;
  objectFit?: 'cover' | 'contain';
}
export function SmartImage({
  src,
  alt,
  className = '',
  aspectRatio = 'aspect-square',
  objectFit = 'cover'
}: SmartImageProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setIsLoaded(true);
    img.onerror = () => setError(true);
  }, [src]);
  return <div className={`relative overflow-hidden ${aspectRatio} ${className} bg-gray-100`} data-id="element-5674" data-mp="1zei1a6vf3hn0">
      <AnimatePresence data-id="element-5675" data-mp="1vd6ba08msuea">
        {!isLoaded && !error && <motion.div initial={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 z-10" data-id="element-5676" data-mp="1qcinrojm2vot">
            <div className="w-full h-full bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 animate-shimmer" style={{
          backgroundSize: '200% 100%'
        }} data-id="element-5677" data-mp="1mnttcvbkpf24" />
          </motion.div>}
      </AnimatePresence>

      {error ? <div className="absolute inset-0 flex items-center justify-center bg-gray-50 text-gray-400" data-id="element-5678" data-mp="1im8jzjy8ziwo">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-5679" data-mp="26bt7mg5cj4ca">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-5680" data-mp="2ad4wgjgebljf" />
          </svg>
        </div> : <motion.img src={src} alt={alt} initial={{
      opacity: 0
    }} animate={{
      opacity: isLoaded ? 1 : 0
    }} transition={{
      duration: 0.4
    }} className={`w-full h-full ${objectFit === 'cover' ? 'object-cover' : 'object-contain'}`} data-id="element-5681" data-mp="pym7fm71l3xo" />}

      <style jsx data-id="element-5682" data-mp="3t6pqi1n685zi">{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
        .animate-shimmer {
          animation: shimmer 2s infinite linear;
        }
      `}</style>
    </div>;
}